import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SiteAdminService } from 'src/app/services/site-admin.service';
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private siteAdminService: SiteAdminService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (environment.maintenance && !this.siteAdminService.getIsSiteAdmin()) {
      this.router.navigate(['/maintenance']);
      return new Observable<HttpEvent<any>>();
    }

    return next.handle(request);
  }
}
